<template>
    <div class="table-responsive">
        <table class="table table-bordered">
            <colgroup>
                <col v-for="field in fields" :key="name+'-col-'+field.key" :width="field.width"/>
            </colgroup>
            <thead>
            <tr>
                <th v-for="field in fields" :key="name+'-'+field.key">{{field.label}}</th>
            </tr>
            </thead>
            <tbody v-if="!list.length">
            <tr>
                <td :colspan="fields.length" class="text-center">No Results.</td>
            </tr>
            </tbody>
            <tbody v-if="list.length > 0">
<!--            <tr v-for="(item,index) in list" :key="name+'-tr-'+index" @click="rowClickEvent(item)" data-toggle="modal" :data-target="targetModal">-->
            <tr v-for="(item,index) in list" :key="name+'-tr-'+index" @click="rowClickEvent(item)" >
                <td v-for="field in fields" :key="name+'-td-'+ field.key">
                    <template v-if="field.slot">
                        <slot :name="field.slot" :data="item" :field="field.key"/>
                    </template>
                    <template v-else>{{item[field.key]}}</template>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "ModalTable",
    props: {
        fields:{
            type: Array,
            required:true
        },
        list: {
            type: Array,
            default: function() {
                return []
            }
        },
        name: {
            type: String,
            default: function() {
                return 'table'
            }
        },
        targetModal: {
            type: String,
            required: true
        }
    },
    mounted() {
    },
    methods: {
        rowClickEvent:function(item) {
            this.$emit('rowClickEvent',item, () => $(this.targetModal).modal('show'))
        }
    }
}
</script>

<style scoped>
.basic-table-border .table {
    border-top:0px !important;
}

a {
    color:#000000;
}
.hover-table table tbody tr:hover {
    background-color: #F8F8F8;
    color: #00C73C !important;
    cursor:pointer
}
.hover-table table tbody tr:hover a{
    color: #00C73C !important;
}
.hover-table table tbody td a:hover{
    cursor:pointer
}
.tb-thead-bg thead {
    background: #F8F8F8;
}
</style>
